"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e) {
  return e && e.preventDefault && e.preventDefault();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-first-router-link/dist/preventDefault.js
// module id = 421
// module chunks = 0